"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNoEmpty = exports.isEmpty = void 0;
require("core-js/modules/es.number.is-nan.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _dataTypeOf = require("./data-type-of");
/** 判断数据是否不为空
 * @description: 判断数据是否不为空
 * @param { * } data 需要处理的命名
 * @param { String } type 判断的数据类型
 * @return { * } 返回判断结果
 */
var isNoEmpty = exports.isNoEmpty = function isNoEmpty(data, type) {
  var dataType = (0, _dataTypeOf.dataTypeOf)(data);
  var status = !!data;
  if (typeof data === 'undefined' || data === null) return false;else if (type && type !== dataType) return false;
  switch (dataType) {
    case 'object':
      status = !!Object.keys(data).length;
      break;
    case 'array':
      status = !!data.length;
      break;
    case 'number':
      status = !Number.isNaN(data);
      break;
    case 'boolean':
      status = true;
      break;
    case 'function':
      status = data.toString() !== 'function () {}';
      break;
  }
  if (type && status) return data;
  return status;
};

/** 判断数据是否为空
 * @description: 判断数据是否为空
 * @param { * } data 需要处理的命名
 * @param { String } type 判断的数据类型
 * @return { Boolean } 返回判断结果
 */
var isEmpty = exports.isEmpty = function isEmpty(data, type) {
  return !isNoEmpty(data, type);
};